module.exports = __webpack_public_path__ + "static/kairos-sans-2590cb3135d528fe5a1965dc89d84865.woff";